import { createApp } from "vue";
import { UiLoading, UiHTMLElement, type UiTypes } from "@various/constants";
import { node } from "@various/utils";

export type UiLoadingShowOption = {
    icon?: string;
    unit?: UiTypes.styleUnit;
    delay?: number;
    message?: string;
};

export type UiLoadingHandles = {
    timer?: NodeJS.Timeout;
    delay: boolean;
    spacing: { x: string; y: string };
    overflow: string;
    open: (config?: UiLoadingShowOption) => void;
    close: (config?: { delay?: number }) => void;
};

//* Loading Show 函数
const show = (config?: UiLoadingShowOption) => {
    //* 数据初始化
    const body = document.body as UiHTMLElement;
    //* 判断body是否已挂载Loading组件
    if (body.instance) {
        //* 属性变更
        if (config?.icon) body.instance.$.props.icon = config.icon;
        if (config?.message) body.instance.$.props.message = config.message;
    } else {
        //* 组件挂载
        //* 创建新的Vue实例
        const app = createApp(UiLoading, Object.assign({ visible: false, mode: "fixed" }, config));
        const instance = app.mount(document.createElement("div"));

        //* 检测是否需要添加Position
        if (body.style.position == "") body.classList.add("ui-relative");

        //* 缓存Loading并将Loading插入body中
        body.app = app;
        body.instance = instance;
        body.appendChild(instance.$el);
    }

    //* 更新Loading状态
    if (!body.instance?.$.props.visible) {
        //* 数据缓存
        $loading.spacing = { x: document.body.style.paddingRight, y: document.body.style.paddingBottom };
        $loading.overflow = document.body.style.overflow;
        //* 隐藏滚动条
        node.scrollbarHidden({ unit: config?.unit });
    }

    //* 显示Loading
    body.instance.$.props.visible = true;
};

//* Loading Hidden 函数
const hidden = () => {
    //* 获取body
    const body = document.body as UiHTMLElement;
    //* 还原body样式
    document.body.style.overflow = $loading.overflow;
    document.body.style.paddingRight = $loading.spacing.x;
    document.body.style.paddingBottom = $loading.spacing.y;
    //* 隐藏Loading
    if (body.instance) {
        body.instance.$.props.visible = false;
    }
};

const $loading: UiLoadingHandles = {
    delay: false, //* 是否延迟关闭
    timer: undefined, //* 定时器
    spacing: { x: "", y: "" }, //* 内间距属性
    overflow: "", //* overflow属性

    //* Loading 激活函数
    open: function (config) {
        //* 清除上一个延时器
        this.timer && clearTimeout(this.timer);
        //* 判断是否需要添加延时器
        if (!config?.delay) show(config);
        else {
            this.timer = setTimeout(() => (show(config), (this.delay = true)), config.delay);
        }
    },

    //* Loading 关闭函数
    close: function (config) {
        //* 清除延时器
        this.timer && clearTimeout(this.timer);
        //* 检测是否需要延迟关闭
        if (!this.delay) return hidden();
        else {
            this.delay = false;
            this.timer = setTimeout(() => hidden(), config?.delay || 200);
        }
    },
};

export { $loading };
export default $loading;
